// tslint:disable-next-line: no-namespace
export namespace Enum {
    export enum CreditScoreStatusType {
        NoScore = 1,
        VeryHighRisk,
        HighRisk,
        MediumHighRisk,
        MediumRisk,
        MediumLowRisk,
        LowRisk,
        VeryLowRisk
    }

    export enum LmsCampaignSourceType {
        CreditCoach = 1,
        CreditConsolidation,
        RegistrationFailedSecurityQuestions,
        RegistrationDebtCounselling,
        RegistrationPersonalLoan,
        PersonalLoan,
        RegistrationFailedOTP,
        RegistrationFailedSecurityQuestionsIncomplete,
        OobaApplicationDeclined,
        OobaCreditCheckDeclined,
        BudgetTool,
        SplDecline,
        CreditConsolidationSolution,
        CreditConsolidationDecline,
        RegistrationNoneCoaching,
        RegistrationNoneZeroTakehomesalary,
        RegistrationDcLite,
        ClientHomePage,
        ClientFaqPage,
        ClientSettingsPage,
        ClientBankAccountsPage,
        ClientSolutionsPage,
        ClientCreditAccountsPage,
        ClientProfilePage,
        ClientWealthPage,
        ClientBudgetPage,
        ClientWealthBalance,
        ClientCreditInsightsPage,
        CreditCardDecline,
        RegistrationDebtCounsellingSPL,
        RegistrationInactiveSPLAutoreg,
        OobaPrequalify,
        OobaAdvance,
        PasswordReset,
        TfgDecline
    }

    export enum OtpType {
        Sms = 1,
        Email = 2
    }

    export enum VersionType {
        ScsRegistration = 1,
        SPLRegistration = 2,
        HLRegistration = 3,
        BranchRegistration = 4
    }
    export const enum WealthScoreCalculationStatus{
        Pending=0,
        Success=200
    }


    export const enum BranchUserLoginType{
        FirstLogin = 1,
        SecondLogin = 2,
        ThirdLoginAndSoOn = 3,
        NotABranchUser = 4
    }


    export enum OobaHomeLoans {
        HighlyLikely = "HighlyLikely",
        ModeratelyLikely = "ModeratelyLikely"
      }
      export enum CampaignType {
        RegistrationPageCampaign = 1,
        LoginPageCampaign = 2
      }
      
}
